var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/search-location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 21C11.7812 21 11.5625 20.9612 11.3438 20.8836C11.125 20.806 10.9297 20.6895 10.7578 20.5343C9.74219 19.6028 8.84375 18.6947 8.0625 17.8098C7.28125 16.925 6.62891 16.0673 6.10547 15.2367C5.58203 14.4062 5.18359 13.6067 4.91016 12.8383C4.63672 12.0699 4.5 11.3364 4.5 10.6378C4.5 8.30919 5.25391 6.45408 6.76172 5.07245C8.26953 3.69082 10.0156 3 12 3C13.9844 3 15.7305 3.69082 17.2383 5.07245C18.7461 6.45408 19.5 8.30919 19.5 10.6378C19.5 11.3364 19.3633 12.0699 19.0898 12.8383C18.8164 13.6067 18.418 14.4062 17.8945 15.2367C17.3711 16.0673 16.7188 16.925 15.9375 17.8098C15.1562 18.6947 14.2578 19.6028 13.2422 20.5343C13.0703 20.6895 12.875 20.806 12.6562 20.8836C12.4375 20.9612 12.2188 21 12 21ZM12 12.3144C12.5156 12.3144 12.957 12.132 13.3242 11.7671C13.6914 11.4023 13.875 10.9638 13.875 10.4515C13.875 9.9392 13.6914 9.50065 13.3242 9.13583C12.957 8.77102 12.5156 8.58862 12 8.58862C11.4844 8.58862 11.043 8.77102 10.6758 9.13583C10.3086 9.50065 10.125 9.9392 10.125 10.4515C10.125 10.9638 10.3086 11.4023 10.6758 11.7671C11.043 12.132 11.4844 12.3144 12 12.3144Z",
    fill: "#B7BBBC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLocation);
export default __webpack_public_path__ + "static/media/search-location.6fbde8b978b08dc2eb8d17c0ac47c68b.svg";
export { ForwardRef as ReactComponent };